import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-unified-sign-up-sign-in',
  templateUrl: './unified-sign-up-sign-in.component.html',
  styleUrls: ['./unified-sign-up-sign-in.component.scss']
})
export class UnifiedSignUpSignInComponent {

  public title = '';

  constructor(activatedRoute: ActivatedRoute) {
    this.title = activatedRoute.snapshot.data.title;
   }
}
